import { render, staticRenderFns } from "./GoogleSignUp.vue?vue&type=template&id=187b69ca&"
import script from "./GoogleSignUp.vue?vue&type=script&lang=js&"
export * from "./GoogleSignUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports